import Tooltip from '@mui/material/Tooltip';

interface HelpTooltipProps {
  /** The help text to display on hover */
  text: string;
  /** Optional icon size in pixels (default 14) */
  size?: number;
}

/**
 * A small info icon that shows explanatory text on hover.
 * Place next to field labels where the purpose isn't obvious.
 */
export default function HelpTooltip({ text, size = 14 }: HelpTooltipProps) {
  return (
    <Tooltip
      title={text}
      arrow
      placement="top"
      enterDelay={200}
      leaveDelay={100}
      slotProps={{
        tooltip: {
          sx: {
            fontSize: '0.8rem',
            maxWidth: 280,
            lineHeight: 1.4,
            padding: '6px 10px',
          },
        },
      }}
    >
      <i
        className="bi bi-info-circle"
        role="img"
        aria-label="Help"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: size,
          color: '#64748b',
          cursor: 'help',
          lineHeight: 1,
          flexShrink: 0,
          marginLeft: 4,
        }}
      />
    </Tooltip>
  );
}
